












import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class QuantityCount extends Vue {
  @Prop() private value!: number;

  @Prop({ default: 28, required: false }) private borderRadius!: number;
}
